export default __webpack_public_path__ + "static/media/video-pause.85ea2db2.svg";